import { Box, Button } from "@mui/material";
import { useShallow } from "zustand/react/shallow";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import styles from "../../../assets/styles/componentStyles/billingStyles/billingFilterTabs.module.scss";

import { CURRENCY_TYPES, CYCLE_TYPES } from "../constant.billing";
import { getAnnualSavePercent } from "../utils.billing";
import { useBillingStore } from "../../../store/billingStore";
import GlobalButton from "../../utility/globalButton/button";
import useGenericHook from "../../../hooks/useGenericHook";

const BillingFilterTabs = () => {

    const { isScreenBelow1000 } = useGenericHook();

    const { billingCycle, billingCurrency, pricingPlans, setBillingTabs } = useBillingStore(useShallow((state) => ({
        billingCycle: state.billingCycle,
        billingCurrency: state.billingCurrency,
        pricingPlans: state.pricingPlans,
        setBillingTabs: state.setBillingTabs,
    })));

    const pricingPageUrl = process.env.REACT_APP_PRICING_PAGE_URL;

    const isMonthly = billingCycle === CYCLE_TYPES.MONTHLY;
    const isAnnually = billingCycle === CYCLE_TYPES.ANNUALLY || billingCycle === CYCLE_TYPES.YEARLY;
    const isINR = billingCurrency === CURRENCY_TYPES.INR;
    const isUSD = billingCurrency === CURRENCY_TYPES.USD;
    const savePercent = getAnnualSavePercent(pricingPlans, billingCurrency);

    return (
        <Box className={styles.tabsRow}>
            <Box className={styles.learnMoreBtn} title="Learn More">
                <GlobalButton
                    buttonText={isScreenBelow1000 ? "" : "Learn More"}
                    className="borderedButtonStyle"
                    endIcon={<OpenInNewIcon />}
                    onClick={() => window.open(pricingPageUrl, "_blank")}
                />
            </Box>

            <Box className={styles.chipGroup}>
                <Button
                    className={`${styles.chipBtn} ${isMonthly ? styles.chipBtnActive : ""}`}
                    onClick={() => setBillingTabs(CYCLE_TYPES.MONTHLY, billingCurrency)}
                    disableRipple
                >
                    Monthly
                </Button>

                <Button
                    className={`${styles.chipBtn} ${isAnnually ? styles.chipBtnActive : ""}`}
                    onClick={() => setBillingTabs(CYCLE_TYPES.ANNUALLY, billingCurrency)}
                    disableRipple
                >
                    Annually
                    {savePercent != null && (
                        <Box component="span" className={styles.saveBadge}>
                            Save {savePercent}%
                        </Box>
                    )}
                </Button>
            </Box>

            <Box className={styles.chipGroup}>
                <Button
                    className={`${styles.chipBtn} ${isINR ? styles.chipBtnActive : ""}`}
                    onClick={() => setBillingTabs(billingCycle, CURRENCY_TYPES.INR)}
                    disableRipple
                >
                    INR
                </Button>
                
                <Button
                    className={`${styles.chipBtn} ${isUSD ? styles.chipBtnActive : ""}`}
                    onClick={() => setBillingTabs(billingCycle, CURRENCY_TYPES.USD)}
                    disableRipple
                >
                    USD
                </Button>
            </Box>
        </Box>
    );
};

export default BillingFilterTabs;
